/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  withRouter,
} from 'react-router-dom';
import {
  ScrollToTopOnMount,
  ExtendedBox,
  ExtendedFlex,
  AnimationContainer,
  ShowMore,
  ResponsiveTabFilter,
  Loader,
} from '../../coreui';

import PageHeading from '../components/PageHeading';
import BrowseNav from '../components/BrowseNav';
import InvestmentTypeDefinition from '../components/InvestmentTypeDefinition';
import InvestmentCards from '../components/InvestmentCards';

import actions from './actions';
import browseActions from '../browsePage/actions';
import RedirectToLoginOnLoggedOut from '../../components/RedirectToLoginOnLoggedOut';

class PastInvestments extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.updateSelectedIoTypeFilterValue = this.updateSelectedIoTypeFilterValue.bind(this);
    this.showMoreClickHandler = this.showMoreClickHandler.bind(this);
  }

  componentDidMount() {
    this.props.getBrowsePageDataRequested();
  }

  updateSelectedIoTypeFilterValue(value) {
    this.props.updateSelectedIoTypeFilterValue(value);
  }

  showMoreClickHandler() {
    this.props.showMoreRequested();
  }

  render() {
    const {
      loaded,
      investments,
      investmentsCount,
      investmentsVisible,
      ioTypes,
      selectedIoTypeFilterValue,
      accreditationRoleStatus,
      gtkyApproved,
      browseNavAnimationSettings,
      updateBrowseNavAnimationSettings,
    } = this.props;

    return (
      <ExtendedFlex
        flexDirection="column"
        align="center"
        bg="gray.1"
        w={[1]}
        {...(investmentsCount <= investmentsVisible ? { pb: 40 } : {})}
        {
        ...(!loaded ? {
          bg: 'gray.0',
          zIndex: 2,
          position: 'relative',
          minHeight: '90vh',
        } : {})
        }
      >
        <ScrollToTopOnMount />
        <RedirectToLoginOnLoggedOut />
        <ExtendedBox
          w={1}
          maxWidth={1600}
        >
          <AnimationContainer
            name="fadeInUp"
            duration="1s"
            fillMode="backwards"
            delay="0s"
          >
            <PageHeading
              title="Past Investments"
              alignment="center"
            />
          </AnimationContainer>
          {
            !loaded &&
            <Loader />
          }
          { loaded &&
            <div>
              <AnimationContainer
                name="fadeIn"
                duration={browseNavAnimationSettings.duration}
                fillMode="backwards"
                delay={browseNavAnimationSettings.delay}
                onEnd={updateBrowseNavAnimationSettings}
              >
                <BrowseNav />
              </AnimationContainer>
              <AnimationContainer
                name="fadeIn"
                duration="1s"
                fillMode="backwards"
                delay="0.75s"
              >
                <ResponsiveTabFilter
                  filterItems={ioTypes}
                  updateSelectedFilterValue={this.updateSelectedIoTypeFilterValue}
                  selectedFilterValue={selectedIoTypeFilterValue}
                />
              </AnimationContainer>
              <AnimationContainer
                name="fadeIn"
                duration="1s"
                fillMode="backwards"
                delay="1s"
              >
                <InvestmentTypeDefinition
                  investmentType={selectedIoTypeFilterValue}
                />
              </AnimationContainer>
              <InvestmentCards
                investments={investments.slice(0, investmentsVisible)}
                investmentsCount={investmentsCount}
                accreditationRoleStatus={accreditationRoleStatus}
                gtkyApproved={gtkyApproved}
              />
            </div> }
          {
            loaded && investmentsCount > investmentsVisible &&
            <ShowMore handleClick={this.showMoreClickHandler} title="Show More" />
          }
        </ExtendedBox>
      </ExtendedFlex>
    );
  }
}

const mapStateToProps = (state) => ({
  loaded: state.pastInvestments.loaded,
  ioTypes: state.pastInvestments.ioTypes,
  selectedIoTypeFilterValue: state.pastInvestments.selectedIoTypeFilterValue,
  investments: state.pastInvestments.investments,
  investmentsCount: state.pastInvestments.investmentsCount,
  investmentsVisible: state.pastInvestments.investmentsVisible,
  accreditationRoleStatus: state.pastInvestments.accreditationRoleStatus,
  gtkyApproved: state.pastInvestments.gtkyApproved,
});

const mapDispatchToProps = (dispatch) => ({
  getBrowsePageDataRequested: () => {
    dispatch(browseActions.getBrowseClosedDataRequested());
  },
  updateSelectedIoTypeFilterValue: (value) => {
    dispatch(actions.updateSelectedPastInvestmentIoTypeFilterValue(value));
  },
  showMoreRequested: (value) => {
    dispatch(actions.updateShowMorePastInvestments(value));
  },
});

PastInvestments.propTypes = {
  loaded: PropTypes.bool,
  ioTypes: PropTypes.arrayOf(PropTypes.object),
  selectedIoTypeFilterValue: PropTypes.oneOf([
    'completed_equity',
    'completed_debt',
    'funded',
  ]),
  updateSelectedIoTypeFilterValue: PropTypes.func,
  investmentsCount: PropTypes.number,
  investmentsVisible: PropTypes.number,
  investments: PropTypes.array,
  showMoreRequested: PropTypes.func,
  accreditationRoleStatus: PropTypes.string,
  gtkyApproved: PropTypes.bool,
  updateBrowseNavAnimationSettings: PropTypes.func,
  browseNavAnimationSettings: PropTypes.object,
  getBrowsePageDataRequested: PropTypes.func,
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(PastInvestments));
